import { Button, Input, Spinner, Typography } from "@material-tailwind/react";
import { useForm, SubmitHandler } from "react-hook-form";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { BASEURL } from "../../../util";
import Logo from "../../../assets/logo.png";
import { GET_ROLE_PERMISSIONS } from "../../../GraphQl/queries";
import { useQuery } from "@apollo/client";

type LoginType = {
  otp: string;
  new_password: string;
};
export default function ChangePassword() {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { isSubmitting, errors },
  } = useForm<LoginType>();

  const onSubmit: SubmitHandler<LoginType> = async (data) => {
    try {
      let options = {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          ...data,
          user_id: localStorage.getItem("user_id"),
        }),
      };

      const req = await fetch(`${BASEURL}/update-password-broker`, options);

      const res = await req.json();

      if (req.ok) {
        if (res?.status === 200) {
          const { data } = res;
          toast.success(
            res?.message ?? "Password reset request sent successfully"
          );
          reset();
          localStorage.removeItem("user_id");
          setTimeout(() => {
            history.push("/");
            window.location.reload();
          }, 1500);
        } else {
          toast.error(res?.data ?? "An error occured");
        }
      } else {
        toast.error(res?.data ?? "An error occured");
      }
    } catch (error: any) {
      toast.error(error?.message);
    }
  };
  return (
    <main className="w-full h-screen bg-white flex items-center justify-center">
      <form onSubmit={handleSubmit(onSubmit)} className="">
        <div className="mb-10 flex items-center justify-center">
          <img src={Logo} alt="logo" className="w-36 object-cover" />
        </div>

        <div>
          <label
            htmlFor="new_password"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Enter OTP code
          </label>
          <div className="mt-2">
            <Input
              crossOrigin={""}
              id="email"
              error={!!errors.otp}
              type="text"
              label="OTP code"
              size="lg"
              className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
              {...register("otp", { required: true })}
            />
          </div>
        </div>

        <div className="mt-5">
          <label
            htmlFor="new_password"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            New Password
          </label>
          <div className="mt-2">
            <Input
              crossOrigin={""}
              id="password"
              error={!!errors.new_password}
              type="password"
              label="New password"
              size="lg"
              className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
              {...register("new_password", { required: true })}
            />
          </div>
        </div>

        <Button
          variant="gradient"
          size="lg"
          type="submit"
          style={{
            background: "#00308F",
          }}
          className="mt-5 flex items-center justify-center font-normal w-full text-sm  leading-none text-white transition duration-300 md:w-96 rounded-2xl hover:bg-purple-blue-600 focus:ring-4 focus:ring-purple-blue-100 bg-purple-blue-500"
        >
          {isSubmitting ? (
            <Spinner className="w-5 h-5 text-white" />
          ) : (
            "Change password"
          )}
        </Button>

        <p className="mt-5 text-center text-sm text-gray-500">
          Take me back to?{" "}
          <a
            href="/"
            className="font-semibold leading-6 text-brand-primary hover:text-brand-primary"
          >
            Login
          </a>
        </p>
      </form>
    </main>
  );
}
